<template>
    <div>
        <div class="title__rank">
            <span v-html="t.earnings"></span>
            <span class="helper__tooltip">
                <span
                    v-html="t.label_tooltip_earnings"
                    class="helper__tooltip--text"
                ></span>
            </span>
        </div>
        <div class="card-v4 container__grid">
            <div class="options">
                <a
                    v-show="!loading"
                    @click="handleDataGeneral('THIS_MONTH')"
                    class="js-btn__opt"
                >{{t.this_month}}</a>
                <a
                    v-show="!loading"
                    @click="handleDataGeneral('LAST_MONTH')"
                    class="js-btn__opt"
                >{{t.last_month}}</a>
                <a
                    v-show="!loading"
                    @click="handleDataGeneral('LAST_3_MONTH')" 
                    class="js-btn__opt"
                >{{t.last_3_month}}</a>
                <a
                    v-show="!loading"
                    @click="handleDataGeneral('LAST_6_MONTH')"
                    class="js-btn__opt"
                >{{t.last_6_month}}</a>
                <a
                    v-show="!loading"
                    @click="handleDataGeneral('ALL_TIME')"
                    class="js-btn__opt active"
                >{{t.all_time}}</a>
                <div class="animation__loading" v-show="loading"></div>
            </div>
            <div class="earnings">
                <h4>{{t.all_earnings}}</h4>
                <div class="box__in">
                    <div class="body">
                        <div class="body__leads">
                            <div>
                                <span>{{t.all_leads}}</span>
                                <span>{{first.leads}}</span>
                            </div>
                            <div>
                                <span>{{t.all_active_leads}}</span>
                                <span>{{first.active_leads}}</span>
                            </div>
                            <div>
                                <span>{{t.number_of_all_affiliates}}</span>
                                <span>{{first.affiliates}}</span>
                            </div>
                        </div>
                        <div class="title__dropdown">
                            <h4>
                                {{whichBtnIsActiveAllEarnings}}
                                <div class="select__level">
                                    <span
                                        @click="handleDataPlans(null, 0, 1, true, 0, 'all')"
                                        class="js-btn__opt__type_all active"
                                    >{{t.label_all_plans}}</span>
                                    <span
                                        @click="handleDataPlans(null, 0, 1, true, 2709, 'all')"
                                        class="js-btn__opt__type_all"
                                    >{{t.label_premium}}</span>
                                    <span
                                        @click="handleDataPlans(null, 0, 1, true, 2706, 'all')"
                                        class="js-btn__opt__type_all"
                                    >{{t.label_essencial}}</span>
                                    <span
                                        @click="handleDataPlans(null, 0, 1, true, 2705, 'all')"
                                        class="js-btn__opt__type_all"
                                    >{{t.label_marketer}}</span>
                                </div>
                            </h4>
                        </div>
                        <div class="body__values">
                            <div>
                                <span>USD</span> 
                                <span>$ {{firstValues.usd}}</span>
                            </div>
                            <div>
                                <span>EUR</span>
                                <span>€ {{firstValues.eur}}</span>
                            </div>
                            <div>
                                <span>BRL</span>
                                <span>R$ {{firstValues.brl}}</span>
                            </div>
                            <!-- <div>
                                <span>BTC</span>
                                <span class="btc__icon">{{first.btc}}</span>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="tier">
                <h4>{{t.first_tier_leads}}</h4>
                <div class="box__in">
                    <div class="body">
                        <div class="body__leads">
                            <div>
                                <span>{{t.all_leads}}</span>
                                <span>{{second.leads}}</span>
                            </div>
                            <div>
                                <span>{{t.all_active_leads}}</span>
                                <span>{{second.active_leads}}</span>
                            </div>
                            <div>
                                <span>{{t.number_of_all_affiliates}}</span>
                                <span>{{second.affiliates}}</span>
                            </div>
                        </div>
                        <div class="title__dropdown">
                            <h4>
                                {{whichBtnIsActiveAllTier1}}
                                <div class="select__level">
                                    <span
                                        @click="handleDataPlans(null, 0, 0, true, 0, 'tier1')"
                                        class="js-btn__opt__type_tier1 active"
                                    >{{t.label_all_plans}}</span>
                                    <span
                                        @click="handleDataPlans(null, 0, 0, true, 2709, 'tier1')"
                                        class="js-btn__opt__type_tier1"
                                    >{{t.label_premium}}</span>
                                    <span
                                        @click="handleDataPlans(null, 0, 0, true, 2706, 'tier1')"
                                        class="js-btn__opt__type_tier1"
                                    >{{t.label_essencial}}</span>
                                    <span
                                        @click="handleDataPlans(null, 0, 0, true, 2705, 'tier1')"
                                        class="js-btn__opt__type_tier1"
                                    >{{t.label_marketer}}</span>
                                </div>
                            </h4>
                        </div>
                        <div class="body__values">
                            <div>
                                <span>USD</span>
                                <span>$ {{secondValues.usd}}</span>
                            </div> 
                            <div>
                                <span>EUR</span>
                                <span>€ {{secondValues.eur}}</span>
                            </div>
                            <div>
                                <span>BRL</span>
                                <span>R$ {{secondValues.brl}}</span>
                            </div>
                            <!-- <div>
                                <span>BTC</span>
                                <span class="btc__icon">{{second.btc}}</span>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="tier tier__indirect">
                <h4>
                    {{t.second_tier_leads}}
                </h4>
                <div class="box__in">
                    <div class="body">
                        <div class="body__leads">
                            <div>
                                <span>{{t.all_leads}}</span>
                                <span>{{third.leads}}</span>
                            </div>
                            <div>
                                <span>{{t.all_active_leads}}</span>
                                <span>{{third.active_leads}}</span>
                            </div>
                            <div>
                                <span>{{t.number_of_all_affiliates}}</span>
                                <span>{{third.affiliates}}</span>
                            </div>
                        </div>
                        <div class="title__dropdown">
                            <h4>
                                {{whichBtnIsActiveAllTier2}}
                                <div class="select__level">
                                    <span
                                        @click="handleDataPlans(null, 1, 1, true, 0, 'tier2')"
                                        class="js-btn__opt__type_tier2 active"
                                    >{{t.label_all_plans}}</span>
                                    <span
                                        @click="handleDataPlans(null, 1, 1, true, 2709, 'tier2')"
                                        class="js-btn__opt__type_tier2"
                                    >{{t.label_premium}}</span>
                                    <span
                                        @click="handleDataPlans(null, 1, 1, true, 2706, 'tier2')"
                                        class="js-btn__opt__type_tier2"
                                    >{{t.label_essencial}}</span>
                                    <span
                                        @click="handleDataPlans(null, 1, 1, true, 2705, 'tier2')"
                                        class="js-btn__opt__type_tier2"
                                    >{{t.label_marketer}}</span>
                                </div>
                            </h4>
                        </div>
                        <div class="body__values">
                            <div>
                                <span>USD</span>
                                <span>$ {{thirdValues.usd}}</span>
                            </div>
                            <div>
                                <span>EUR</span>
                                <span>€ {{thirdValues.eur}}</span>
                            </div>
                            <div>
                                <span>BRL</span>
                                <span>R$ {{thirdValues.brl}}</span>
                            </div>
                            <!-- <div>
                                <span>BTC</span>
                                <span class="btc__icon">{{third.btc}}</span>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
    name: "all-values-user",
    props: ["props"],
    components: {},
    data() {
        return {
            allValues: {},
            t: this.$parent.view.translation.allValuesUser,
            allData: this.$parent.view.dashboard_values_v3.all_values,
            loading: false,
            currentTime: "ALL_TIME",
            currentStartLevel: 0,
            currentEndLevel: 0,
            firstRound: false,
            whichBtnTypeIsActive: 0,
            hostMicroservice: window.__env.microservices.bucket.host, 
            selectedLevel: 1,
            whichBtnIsActiveAllEarnings: this.$parent.view.translation.allValuesUser.label_all_plans,
            whichBtnIsActiveAllTier1: this.$parent.view.translation.allValuesUser.label_all_plans,
            whichBtnIsActiveAllTier2: this.$parent.view.translation.allValuesUser.label_all_plans,
            lastPlanAllEarnings: 0,
            lastPlanAllTier1: 0,
            lastPlanAllTier2: 0,
            isAmbassador:
                this.$parent.view.IS_AMBASSADOR ||
                this.$parent.view.IS_AMBASSADOR_PLUS
                    ? true
                    : false,
            first: { 
                leads: 0,
                active_leads: 0,
                affiliates: 0,
            },
            firstValues: {
                usd: 0,
                eur: 0,
                brl: 0,
                btc: 0
            },
            second: {
                leads: 0,
                active_leads: 0,
                affiliates: 0,
            },
            secondValues: {
                usd: 0,
                eur: 0,
                brl: 0,
                btc: 0
            },
            third: {
                leads: 0,
                active_leads: 0,
                affiliates: 0
            },
            thirdValues: {
                usd: 0,
                eur: 0,
                brl: 0,
                btc: 0
            }
        };
    },
    methods: {
        /*
            type = tempo 
            levelStart = nivel inciail da rede,
            levelEnd = nivel final da rede,
            onlyLevel = se quer buscar somente level,
        */
        handleDataGeneral(
            type = "ALL_TIME",
            levelStart = 0,
            levelEnd = 1,
            onlyLevel = false
        ) {
            this.loading = true;
            let vm = this;
            this.currentTime = type;
            fetch(
                `${this.hostMicroservice}/users/${this.$parent.view.dados_usuario_office.id}/level-br?start=${levelStart}&end=${levelEnd}&period=${this.currentTime}`,
                // `http://localhost:8080/users/${this.$parent.view.dados_usuario_office.id}/level-br?start=${levelStart}&end=${levelEnd}&period=${this.currentTime}`,
                // `${this.hostMicroservice}/users/130025/level?start=${levelStart}&end=${levelEnd}&period=${this.currentTime}`, //freedman test
                {
                    mode: "cors",
                    headers: {
                        Origin: "*"
                    }
                } 
            )
                .then(res => {
                    return res.text();  
                })
                .then(data => {
                    vm.loading = false;
                    this.allResponse = JSON.parse(data);

                    if(vm.firstRound) {
                        //vai fazer as chamadas dos valores
                        vm.handleDataPlans(type, 0, 1, true, vm.lastPlanAllEarnings, 'all', false);
                        vm.handleDataPlans(type, 0, 0, true, vm.lastPlanAllTier1, 'tier1', false);
                        vm.handleDataPlans(type, 1, 1, true, vm.lastPlanAllTier2, 'tier2', false);
                    } else {
                        vm.firstValues = { 
                            usd: this.allResponse.earningsUSD,
                            eur: this.allResponse.earningsEUR,
                            brl: this.allResponse.earningsBRL,
                            btc: 0
                        };
                        vm.secondValues = {
                            usd: this.allResponse.earningsTier1USD,
                            eur: this.allResponse.earningsTier1EUR,
                            brl: this.allResponse.earningsTier1BRL,
                            btc: 0
                        };
                        vm.thirdValues = {
                            usd: this.allResponse.earningsTier2USD,
                            eur: this.allResponse.earningsTier2EUR,
                            brl: this.allResponse.earningsTier2BRL,
                            btc: 0
                        }
                    }
                    
                    
                   //insere no objecto que armazena somente os leads
                    vm.first = {
                        leads: this.allResponse.allLeads,
                        active_leads: this.allResponse.allActiveLeads,
                        affiliates: this.allResponse.allAffiliate,
                    }; 
                    vm.second = {
                        leads: this.allResponse.allTier1Leads,
                        active_leads: this.allResponse.allTier1ActiveLeads,
                        affiliates: this.allResponse.allTier1Affiliate,
                    };
                    vm.third = {
                        leads: this.allResponse.allTier2Leads,
                        active_leads: this.allResponse.allTier2ActiveLeads,
                        affiliates: this.allResponse.allTier2Affiliate,
                    }; 

                    vm.firstRound = true;
                });
        },
        /*
            type = tempo 
            levelStart = nivel inciail da rede,
            levelEnd = nivel final da rede,
            onlyLevel = se quer buscar somente level,
            plan = id do plano,
            typeOption = tipo da busca - all, tier1 e tier2,
            chooseFromTime = se foi escolhio pelo botao ou foi a chamada automatica da linha 322
        */
        handleDataPlans(
            type = "ALL_TIME",
            levelStart = 0,
            levelEnd = 1,
            onlyLevel = false,
            plan = 0,
            typeOption = 'all',
            chooseFromTime = true
            // <test>
                //2528 - premium
                //2527 - essencial
                //2526 - marketer
            // </test>
            // <prod>
                //2709 - premium
                //2706 - essencial
                //2705 - marketer
            // </prod>
        ) {
            this.loading = true;
            let vm = this;
            fetch(`${this.hostMicroservice}/users/${this.$parent.view.dados_usuario_office.id}/level-by-plan?start=${levelStart}&end=${levelEnd}&period=${this.currentTime}&plan=${plan}`,{mode: "cors",headers: {Origin: "*"}} )
            // fetch(`${this.hostMicroservice}/users/130025/level-by-plan?start=${levelStart}&end=${levelEnd}&period=${this.currentTime}&plan=${plan}`,{mode: "cors",headers: {Origin: "*"}} ) // teste freedman
                .then(res => {
                    return res.text();  
                })
                .then(data => {
                    vm.loading = false;
                    vm.allResponse = JSON.parse(data);

                    //se foi o all_earnings vai buscar toda a rede, entao comeca no nival 1 e vai ate o 1
                    if(levelStart == 0 && levelEnd == 1) {

                        //se nao foi feito a chamada automatica vai gravar o ultimo clique para manter na memoria o tipo de plano seleciona
                        if(chooseFromTime) vm.lastPlanAllEarnings = plan;
                        if(vm.lastPlanAllEarnings == 0)    vm.whichBtnIsActiveAllEarnings = vm.t.label_all_plans;
                        if(vm.lastPlanAllEarnings == 2709) vm.whichBtnIsActiveAllEarnings = vm.t.label_premium;
                        if(vm.lastPlanAllEarnings == 2706) vm.whichBtnIsActiveAllEarnings = vm.t.label_essencial;
                        if(vm.lastPlanAllEarnings == 2705) vm.whichBtnIsActiveAllEarnings = vm.t.label_marketer;
                        
                        vm.firstValues = { 
                            usd: vm.allResponse.earningsUSD,
                            eur: vm.allResponse.earningsEUR,
                            brl: vm.allResponse.earningsBRL,
                            btc: 0
                        };
                    }
                    if(levelStart == 0 && levelEnd == 0) {
                        
                        if(chooseFromTime) vm.lastPlanAllTier1 = plan;
                        if(vm.lastPlanAllTier1 == 0)    vm.whichBtnIsActiveAllTier1 = vm.t.label_all_plans;
                        if(vm.lastPlanAllTier1 == 2709) vm.whichBtnIsActiveAllTier1 = vm.t.label_premium;
                        if(vm.lastPlanAllTier1 == 2706) vm.whichBtnIsActiveAllTier1 = vm.t.label_essencial;
                        if(vm.lastPlanAllTier1 == 2705) vm.whichBtnIsActiveAllTier1 = vm.t.label_marketer;
                        vm.secondValues = {
                            usd: vm.allResponse.earningsUSD,
                            eur: vm.allResponse.earningsEUR,
                            brl: vm.allResponse.earningsBRL,
                            btc: 0
                        };
                    }
                    if(levelStart == 1 && levelEnd == 1) {
                        
                        if(chooseFromTime) vm.lastPlanAllTier2 = plan;
                        if(vm.lastPlanAllTier2 == 0)    vm.whichBtnIsActiveAllTier2 = vm.t.label_all_plans;
                        if(vm.lastPlanAllTier2 == 2709) vm.whichBtnIsActiveAllTier2 = vm.t.label_premium;
                        if(vm.lastPlanAllTier2 == 2706) vm.whichBtnIsActiveAllTier2 = vm.t.label_essencial;
                        if(vm.lastPlanAllTier2 == 2705) vm.whichBtnIsActiveAllTier2 = vm.t.label_marketer;
                        vm.thirdValues = {
                            usd: vm.allResponse.earningsUSD,
                            eur: vm.allResponse.earningsEUR,
                            brl: vm.allResponse.earningsBRL,
                            btc: 0
                        }
                    }
                });
        }
    },
    mounted() {
        //btn lateral
        let buttons = document.querySelectorAll(".js-btn__opt");
        for (let i = 0; i < buttons.length; i++) {
            const element = buttons[i];
            element.addEventListener('click', function () {
                for (let j = 0; j < buttons.length; j++) buttons[j].classList.remove('active');
            this.classList.add('active');
            });
        }
        //btn all earnings
        let buttonsAllEarning = document.querySelectorAll(".js-btn__opt__type_all");
        for (let i = 0; i < buttonsAllEarning.length; i++) {
            const element = buttonsAllEarning[i];
            element.addEventListener('click', function () {
                for (let j = 0; j < buttonsAllEarning.length; j++) buttonsAllEarning[j].classList.remove('active');
            this.classList.add('active');
            });
        }
        //btn tier 1
        let buttonsTier1 = document.querySelectorAll(".js-btn__opt__type_tier1");
        for (let i = 0; i < buttonsTier1.length; i++) {
            const element = buttonsTier1[i];
            element.addEventListener('click', function () {
                for (let j = 0; j < buttonsTier1.length; j++) buttonsTier1[j].classList.remove('active');
            this.classList.add('active');
            });
        }
        //btn tier 2
        let buttonsTier2 = document.querySelectorAll(".js-btn__opt__type_tier2");
        for (let i = 0; i < buttonsTier2.length; i++) {
            const element = buttonsTier2[i];
            element.addEventListener('click', function () {
                for (let j = 0; j < buttonsTier2.length; j++) buttonsTier2[j].classList.remove('active');
            this.classList.add('active');
            });
        }

        //chamadas iniciais para popular com o conteudo
        this.handleDataGeneral();
        // this.handleDataPlans(null, 0, 100, true, 0, 'all', false);
        // this.handleDataPlans(null, 0, 0, true, 0, 'tier1', false);
        // this.handleDataPlans(null, 1, 1, true, 0, 'tier2', false);
        
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$primary: var(--theme-color-primary);
@mixin h4Title {
    text-transform: uppercase;
    color: $primary;
    position: relative;
    text-align: center;
    margin-bottom: 3rem;
}
.title__rank {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    .helper__tooltip::after {
        top: -8px;
    }
}
.all__values {
    margin-top: 1.5rem;
    .card-v4 {
        padding: 1rem;
        margin-bottom: 0;
        border-radius: 0;
        border-bottom: 0;
    }
    .options {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        border: 0.5px solid rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        padding: 0.5rem;
        margin-top: 35px;
        a {
            background: #fbfbfb;
            border-radius: 4px;
            padding: 1rem 2rem;
            color: rgba(112, 112, 112, 0.5);
            text-align: center;
            font-weight: bold;
            margin: 0.2rem 0;
            font-size: 0.9rem;
            transition: 0.2s all ease;
            -webkit-touch-callout: none;
            -webkit-user-select: none;
            -khtml-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            &.active,
            &:hover {
                background: var(--theme-color-accent);
                color: white;
            }
        }
    }
    .container__grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 20px;
        & > div {
            .box__in {
                border: 0.5px solid rgba(0, 0, 0, 0.12);
                border-radius: 4px;
                padding: 1rem;
            }
            &:last-child {
                border-right: none;
            }
        }
        .earnings,
        .tier {
            h4 {
                @include h4Title;
                margin-bottom: 1rem;
            }
            .body {
                padding: 0.4rem 0;
                .body__leads {
                    position: relative;
                    margin-bottom: 1rem;
                    display: flex;
                    flex-direction: column;
                    div {
                        display: flex;
                        justify-content: space-between;
                        padding: 0.6rem 0;
                        span {
                            font-size: 0.9rem;
                            font-weight: bold;
                            &:first-child {
                                text-transform: uppercase;
                                color: $primary;
                            }
                            &:last-child {
                                color: var(--theme-color-accent);
                            }
                        }
                    }
                }
                .body__values {
                    display: flex;
                    flex-direction: column;
                    div {
                        display: flex;
                        justify-content: space-between;
                        padding: 0.6rem 0;
                        border-bottom: 0.5px solid rgba(0, 0, 0, 0.12);
                        &:last-child {
                            border-bottom: none;
                        }
                        span {
                            font-size: 0.9rem;
                            font-weight: bold;
                            &:first-child {
                                text-transform: uppercase;
                                color: $primary;
                            }
                            &:last-child {
                                color: #0cad25;
                            }
                            &.btc__icon {
                                background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCAyNCAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjQgMTYuNkMyMS4yIDE1LjcgMjEuNyAxNCAyMS40IDExLjNDMjEuMSA3LjYgMTggNi4zIDEzLjkgNlYwLjIwMDAwMUwxMC43IDAuOTAwMDAyVjUuOUM5LjkgNS45IDkgNS45IDguMiA1LjlWMEw1IDAuNzk5OTk5VjZDMy44IDYgNC42IDYgMC43OTk5OTkgNkwwIDkuNEMyLjUgOS40IDIuNCA5LjIgMi43IDEwLjhWMjVDMi41IDI2LjMgMy4xIDI2LjEgMC45MDAwMDIgMjZMMCAyOS44QzUuOCAyOS44IDUgMjkuOCA1IDI5LjhWMzQuMkw4LjIgMzMuMlYyOS44QzkuMSAyOS44IDkuOSAyOS44IDEwLjcgMjkuOFYzNC4xTDEzLjkgMzMuMVYyOS42QzE5LjIgMjkuMyAyMy4xIDI4IDIzLjUgMjNDMjMuOSAxOS4xIDIyLjQgMTcuMyAxOS40IDE2LjZaTTguMyA5LjVDMTAuMSA5LjUgMTcuMSA4LjkgMTcuMSAxMi43QzE3LjEgMTYuMiAxMC4xIDE1LjggOC4zIDE1LjhWOS41Wk04LjMgMjUuOVYxOUMxMC40IDE5IDE4LjQgMTguNCAxOC40IDIyLjVDMTguNCAyNi40IDEwLjUgMjUuOSA4LjMgMjUuOVoiIGZpbGw9IiMwQ0FEMjUiLz4KPC9zdmc+);
                                padding-left: 20px;
                                background-size: 20px 14px;
                                background-repeat: no-repeat;
                            }
                        }
                    }
                }
            }
        }
        .title__dropdown {
            h4 {
                border: 0.5px solid rgba(0, 0, 0, 0.12);
                padding: 0.8rem 3rem 0.6rem 1rem;
                width: 95%;
                margin: 0 auto 8px auto;
                cursor: pointer;
                border-radius: 4px;
                transition: 0.3s all;
                background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMS40MSA3LjQxTDYgMi44M0wxMC41OSA3LjQxTDEyIDZMNiAzLjI5MDE2ZS0wNkwxLjIzMjY2ZS0wNyA2TDEuNDEgNy40MVoiIGZpbGw9IiM3RTFBRkQiLz4KPC9zdmc+);
                background-repeat: no-repeat;
                background-position: 95% center;
                position: relative;
                text-transform: uppercase;
                &:hover {
                    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTIgOCIgZmlsbD0ibm9uZSIgc3R5bGU9IiYjMTA7ICAgIHRyYW5zZm9ybTogcm90YXRlKDE4MGRlZyk7JiMxMDsiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEuNDEgNy40MUw2IDIuODNMMTAuNTkgNy40MUwxMiA2TDYgMy4yOTAxNmUtMDZMMS4yMzI2NmUtMDcgNkwxLjQxIDcuNDFaIiBmaWxsPSIjN0UxQUZEIi8+Cjwvc3ZnPg==);
                    .select__level {
                        display: flex;
                    }
                }
                .select__level {
                    position: absolute;
                    left: 0;
                    top: 38px;
                    width: 100%;
                    display: none;
                    flex-direction: column;
                    background: white;
                    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                    border-radius: 4px;
                    z-index: 1;
                    span {
                        padding: 0.8rem 2.9rem;
                        transition: 0.2s all;
                        &:hover {
                            background: rgba(102, 179, 255, 0.17);
                        }
                        &.active {
                            display: none;
                        }
                    }
                }
            }
        }
        .animation__loading {
            height: 30px;
            width: 30px;
            border-radius: 100%;
            border: 2px solid $primary;
            border-top-color: white;
            border-bottom-color: white;
            animation: rotation 0.9s linear infinite;
            display: flex;
            align-self: center;
            justify-self: center;
        }

        @keyframes rotation {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }
    }
}
@media (max-width: 980px) {
    .all__values .container__grid {
        grid-template-columns: 1fr;
    }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/rank/components/allValuesUserBR.vue